export default __webpack_public_path__ + "static/media/tian_win.19a7eab1.gif";